import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { resolver } from "../../../API/middlewares/resolveRequests";
import { getCommunities } from "../../../API/store/actions/admin/communitiesAction";
import AdminHome from "../adminHome";
import CommunitiesAlerts from "./communitiesAlerts";
import Lang from "../../../userPreferences/staticWords";

const CommunitiesList = ({ userToken }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [communities, setCommunities] = useState(null);
  const reload = useSelector((state) => state.reload.reload);

  const [modalVisible, setModalVisible] = useState({
    addCommunity: false,
    addUser: false,
    deleteCommunity: false,
    editCommunity: false,
    helperData: null,
  });
  useEffect(() => {
    resolver(getCommunities, setCommunities, currentPage, 10, userToken);
  }, [currentPage, reload]);
  if (communities)
    return (
      // AddCommunityForm
      <>
        <CommunitiesAlerts
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          userToken={userToken}
        />
        <AdminHome
          data={communities}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          title={Lang.communitiesMenu}
          listType={"communities"}
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
        />
      </>
    );
  return <>LOADING</>;
};
export default CommunitiesList;
